import * as FileSystem from 'fs';
import { fetchPreviewImage } from '../FetchFromAPI';
import { Magazine } from '../Datatypes';

export const useGetPreviewImage = () => {
    return async (magazine: Magazine): Promise<string> => {
        //console.log(`useGetPreviewImage - try image for ${magazine.date}${magazine.edition}`);
        try {
            const filePath = `${FileSystem.documentDirectory}epaper/previewImages/${magazine.date}.${magazine.edition}.jpg`;
            const fileInfo = await FileSystem.getInfoAsync(filePath);

            if (fileInfo.exists) {
                return filePath;
            } else {
                const downloaded = await fetchPreviewImage(magazine);
                if (downloaded) {
                    //console.log(`Preview image for ${magazine.date}${magazine.edition} downloaded`);
                    return filePath;
                } else {
                    console.error(`Failed to download preview image for ${magazine.date}-${magazine.edition}`);
                    return '';
                }
            }
        } catch (error) {
            console.error(`Error fetching preview image for ${magazine.date}-${magazine.edition}:`, error);
            return '';
        }
    };
};